
import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import CursoPage from '@/pages/curso/page';
import ModulosPage from '@/pages/modulos/page';
import PreciosPage from '@/pages/precios/page';
import PagoPage from '@/pages/pago/page';
import PresentacionPage from '@/pages/presentacion/page';
import NotFoundPage from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <PresentacionPage />,
  },
  {
    path: '/home',
    element: <HomePage />,
  },
  {
    path: '/presentacion',
    element: <PresentacionPage />,
  },
  {
    path: '/curso',
    element: <CursoPage />,
  },
  {
    path: '/modulos',
    element: <ModulosPage />,
  },
  {
    path: '/precios',
    element: <PreciosPage />,
  },
  {
    path: '/pago',
    element: <PagoPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
